import { useEffect, useState } from "react";

const CLINIC_ID = "6a3ba96dc8e05c65af7f0ef0";
const BASE_URL = "https://api.avexa.net/clinic-onboarding";

export function useDoctors() {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    const fetchProviders = async () => {
      try {
        // Step 1: fetch providers list
        const res = await fetch(`${BASE_URL}/clinics/${CLINIC_ID}/providers`);
        if (!res.ok) throw new Error("Failed to fetch providers");
        const data = await res.json();
        const providerList = data.providers ?? [];

        // Step 2: enrich each provider with their profile
        const enriched = await Promise.all(
          providerList.map(async (provider) => {
            try {
              const profileRes = await fetch(
                `${BASE_URL}/clinics/${CLINIC_ID}/providers/${provider.providerId}/onboarding/profile`
              );
              if (!profileRes.ok) return provider; // fallback to base data
              const profile = await profileRes.json();
              return { ...provider, ...profile };
            } catch {
              return provider; // fallback silently
            }
          })
        );

        if (!cancelled) setDoctors(enriched);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchProviders();
    return () => {
      cancelled = true; // avoid setState after unmount
    };
  }, []);

  return { doctors, loading, error };
}